import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend from 'i18next-http-backend';

const BANNER_ORIGIN = "https://foundation-donate-banner.netlify.app/";

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    debug: process.env.NODE_ENV === 'development',
    load: 'languageOnly',
    interpolation: {
      escapeValue: false
    },
    backend: {
      loadPath: `${BANNER_ORIGIN}/locales/{{lng}}/translation.json`
    }
  });

export default i18n;